import React from 'react';
import { getStyle } from '../../components';
import { observer } from 'mobx-react';
import './IndexItem.less';

@observer
class EmptyView extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'index-item',
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            data: this.props.data
        };
    }

    render() {
        const {prefixCls, data, onPushDetail, isOrderList, styles = {}} = this.props;
        let style = getStyle(this.props);
        let returnNode: any = null;
        if (data.zorderStatus == 5) {
            returnNode = `退货中：${data.returnNum}件`;
        } else if (data.zorderStatus == 7) {
            returnNode = `已退：${data.returnNum}件`;
        }
        return (
            <div style={style} className={`${prefixCls}`}>
                <div
                    className={prefixCls + 'item_box'}
                    onClick={onPushDetail}
                    style={isOrderList ? {padding: '1rem 1.6rem'} : styles}
                >
                    <div className={prefixCls + 'top_img'}>
                        <div>
                            {data.productImage ? <img src={data.productImage} alt=""/> : ''}
                        </div>
                    </div>
                    <div className={prefixCls + 'main_box'}>
                        <div className={prefixCls + 'main_name'}>{data.productName}</div>
                        <div className={`${prefixCls}con_box clearfix`}>
                            <div className={prefixCls + 'main_con'}
                                 style={data.returnNum ? {} : {
                                     width: '100%'
                                 }}>{data.skuValue && data.skuValue.replace(/\s+/g, '，')}</div>
                            {data.returnNum && <div className={`${prefixCls}partReturn`}>{returnNode}</div>}
                        </div>
                        <div className={prefixCls + 'main_name_box'}>
                            <div className={prefixCls + 'main_pic'}>
                                {data.vipPrice ? '￥' + (data.vipPrice && data.vipPrice.toFixed(2)) : ''}
                            </div>
                            <div className={prefixCls + 'main_number'}><span>X</span>{data.num || data.buyNum}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmptyView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/IndexItem.tsx